/* Ember — Fast Grill theme JS (no dependencies) */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const T = window.theme || { routes: {}, strings: {} };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */
  function money(cents) {
    const fmt = T.money_format || 'LE {{amount}}';
    const n = (cents / 100);
    const withDec = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const noDec = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, withDec).replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec.replace('.', ','));
  }
  let toastTimer;
  function toast(msg) {
    const el = $('#Toast'); if (!el) return;
    el.textContent = msg; el.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { el.hidden = true; }, 2600);
  }
  function lockScroll(lock) { document.documentElement.style.overflow = lock ? 'hidden' : ''; }
  function trapEsc(cb) { document.addEventListener('keydown', e => { if (e.key === 'Escape') cb(); }); }

  /* ---------- header ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }
  /* announcement rotation */
  $$('[data-announcement]').forEach(bar => {
    const items = $$('.announcement__item', bar); if (items.length < 2) return;
    let i = 0; const iv = parseInt(bar.dataset.interval, 10) || 4000;
    setInterval(() => { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, iv);
  });

  /* ---------- overlays live on <body> so header transforms never offset them ---------- */
  function hoist() { $$('[data-nav],[data-search]').forEach(el => { if (el.parentElement !== document.body) document.body.appendChild(el); }); }
  hoist();
  /* ---------- mobile nav ---------- */
  const nav = $('[data-nav]');
  function navToggle(open) {
    if (!nav) return; nav.setAttribute('aria-hidden', open ? 'false' : 'true'); lockScroll(open);
    $$('[data-nav-open]').forEach(b => b.setAttribute('aria-expanded', open));
    if (open) { const panel = $('.mnav__panel', nav); if (panel) panel.scrollTop = 0; const f = $('button[data-nav-close]', nav); f && f.focus({ preventScroll: true }); }
  }
  $$('[data-nav-open]').forEach(b => b.addEventListener('click', () => navToggle(true)));
  $$('[data-nav-close]').forEach(b => b.addEventListener('click', () => navToggle(false)));

  /* ---------- search ---------- */
  const search = $('[data-search]');
  function searchToggle(open) {
    if (!search) return; search.setAttribute('aria-hidden', open ? 'false' : 'true'); lockScroll(open);
    if (open) setTimeout(() => $('[data-search-input]', search).focus(), 50);
  }
  $$('[data-search-open]').forEach(b => b.addEventListener('click', () => searchToggle(true)));
  $$('[data-search-close]').forEach(b => b.addEventListener('click', () => searchToggle(false)));
  const sInput = $('[data-search-input]'); const sResults = $('[data-search-results]');
  if (sInput && sResults && T.routes.predictive_search) {
    let t;
    sInput.addEventListener('input', () => {
      clearTimeout(t); const q = sInput.value.trim();
      if (q.length < 2) { sResults.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const r = await fetch(`${T.routes.predictive_search}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`);
          if (r.ok) { const html = await r.text(); const doc = new DOMParser().parseFromString(html, 'text/html'); const inner = doc.querySelector('#PredictiveSearchResults'); sResults.innerHTML = inner ? inner.innerHTML : ''; return; }
        } catch (e) {}
        // fallback JSON API
        try {
          const r = await fetch(`${T.routes.predictive_search}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
          const d = await r.json(); const ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          sResults.innerHTML = ps.length ? ps.map(p => `<a class="search-results__item" href="${p.url}">${p.image ? `<img src="${p.image}&width=104" alt="">` : ''}<div><strong>${p.title}</strong><span>${p.price ? money(Math.round(parseFloat(p.price) * 100)) : ''}</span></div></a>`).join('') : `<p class="search-results__empty">${T.strings.error || ''}</p>`;
        } catch (e) { sResults.innerHTML = ''; }
      }, 220);
    });
  }

  /* ---------- reveal on scroll ---------- */
  const revealEls = $$('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window && !reduceMotion) {
    const io = new IntersectionObserver(entries => { entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -4% 0px', threshold: 0.05 });
    revealEls.forEach(el => { const r = el.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) { el.classList.add('is-visible'); } else { io.observe(el); } });
    // safety net: anything still hidden after a while becomes visible
    setTimeout(() => revealEls.forEach(el => { const r = el.getBoundingClientRect(); if (r.top < window.innerHeight * 1.2) el.classList.add('is-visible'); }), 1500);
  } else { revealEls.forEach(el => el.classList.add('is-visible')); }

  /* ---------- videos: lazy source + rendition picking ---------- */
  function playSafe(v) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
  const conn = navigator.connection || {};
  const slowNet = !!conn.saveData || /(^|\s)(slow-2g|2g|3g)$/.test(conn.effectiveType || '');
  function pickSrc(v) {
    const r = v.getBoundingClientRect();
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    let need = Math.max(r.width, r.height * 0.5625) * dpr; // width the rendition must cover
    if (v.dataset.play === 'hero' && window.innerWidth < 768) need = Math.min(need, 800); // phone hero: 720p is plenty behind an overlay
    if (slowNet || need <= 560) return v.dataset.sd || v.dataset.hd || v.dataset.fhd;
    if (need <= 1000) return v.dataset.hd || v.dataset.fhd || v.dataset.sd;
    return v.dataset.fhd || v.dataset.hd || v.dataset.sd;
  }
  /* Liquid only exposes the 1080p MP4 + HLS playlist for theme videos. The playlist lists every
     rendition and Shopify names the MP4s with the same tokens, so we derive 480p/720p URLs from it. */
  const renditionCache = {};
  async function resolveRenditions(v) {
    if (v.dataset.resolved) return;
    const hls = v.dataset.hls, fhd = v.dataset.fhd || '';
    if (!hls || !fhd || v.dataset.sd !== fhd) { v.dataset.resolved = '1'; return; } // Liquid already gave us real renditions
    const key = hls.split('/').pop().split('?')[0];
    let map = renditionCache[key];
    if (!map) { try { map = JSON.parse(sessionStorage.getItem('vr:' + key) || 'null'); } catch (e) { map = null; } }
    if (!map) {
      map = {};
      try {
        const txt = await (await fetch(hls, { cache: 'force-cache' })).text();
        const lines = txt.split('\n');
        for (let i = 0; i < lines.length; i++) {
          const m = lines[i].match(/RESOLUTION=(\d+)x(\d+)/); if (!m) continue;
          const uri = (lines[i + 1] || '').trim();
          const tok = uri.match(/\.([A-Z]+-\d+p\.[\d.]+Mbps\.hls\.\d+)_?\.m3u8/);
          if (!tok) continue;
          const mp4tok = tok[1].replace(/^([A-Z]+-\d+p)\.([\d.]+Mbps)\.hls\.(\d+)$/, '$1-$2-$3');
          map[parseInt(m[2], 10)] = fhd.replace(/\.[A-Z]+-\d+p-[\d.]+Mbps-\d+\.mp4/, '.' + mp4tok + '.mp4');
        }
        try { sessionStorage.setItem('vr:' + key, JSON.stringify(map)); } catch (e) {}
      } catch (e) { map = {}; }
      renditionCache[key] = map;
    }
    const hs = Object.keys(map).map(Number).sort((a, b) => a - b);
    if (hs.length) {
      v.dataset.sd = map[hs[0]];
      v.dataset.hd = map[hs.find(h => h >= 700) || hs[hs.length - 1]];
      v.dataset.fhd = map[hs[hs.length - 1]] || fhd;
    }
    v.dataset.resolved = '1';
  }
  async function loadVideo(v, autoplay) {
    if (!v.dataset.loaded) {
      v.dataset.loaded = '1';
      await resolveRenditions(v);
      const src = pickSrc(v); if (!src) { delete v.dataset.loaded; return; }
      const fallback = v.dataset.hls ? (v.dataset.fhd || '') : '';
      v.addEventListener('error', () => { if (fallback && v.src !== fallback && !v.dataset.fellBack) { v.dataset.fellBack = '1'; v.src = fallback; if (autoplay) playSafe(v); } }, { once: false });
      v.src = src; v.preload = 'auto';
    }
    if (autoplay) { v.muted = true; v.setAttribute('playsinline', ''); playSafe(v); }
  }
  window.themeLoadVideo = loadVideo;
  /* hero: only the visible one (desktop vs mobile) ever loads */
  $$('[data-video][data-play="hero"]').forEach(v => { if (getComputedStyle(v).display !== 'none' && v.getBoundingClientRect().width > 0) loadVideo(v, true); });
  window.addEventListener('resize', () => { $$('[data-video][data-play="hero"]').forEach(v => { if (!v.dataset.loaded && getComputedStyle(v).display !== 'none' && v.getBoundingClientRect().width > 0) loadVideo(v, true); }); }, { passive: true });
  /* in-view videos: load + play when ~visible, pause when gone */
  const vidIO = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(en => { const v = en.target; if (en.isIntersecting) { loadVideo(v, true); } else if (v.dataset.loaded) { v.pause(); } });
  }, { threshold: 0.25, rootMargin: '120px 0px' }) : null;
  $$('[data-video][data-play="inview"]').forEach(v => { v.removeAttribute('controls'); vidIO ? vidIO.observe(v) : loadVideo(v, true); });
  /* manual videos (gallery, modal): load when the user asks for them */
  $$('[data-video][data-play="manual"]').forEach(v => { v.addEventListener('play', () => loadVideo(v, false), { once: true }); v.addEventListener('click', () => { if (!v.dataset.loaded) { loadVideo(v, false); playSafe(v); } }, { once: true }); });
  $$('[data-ugc-sound]').forEach(btn => {
    btn.addEventListener('click', () => {
      const card = btn.closest('[data-ugc-card]'); const v = $('video', card); if (!v) return;
      const on = btn.getAttribute('aria-pressed') !== 'true';
      $$('[data-ugc-card] video').forEach(o => { if (o !== v) { o.muted = true; const b = $('[data-ugc-sound]', o.closest('[data-ugc-card]')); b && b.setAttribute('aria-pressed', 'false'); } });
      loadVideo(v, false); v.muted = !on; btn.setAttribute('aria-pressed', on); playSafe(v);
    });
  });
  /* scroller arrows */
  $$('[data-scroll-prev],[data-scroll-next]').forEach(btn => {
    btn.addEventListener('click', () => {
      const sec = btn.closest('section'); const sc = $('[data-scroller]', sec); if (!sc) return;
      const dir = btn.hasAttribute('data-scroll-next') ? 1 : -1; const rtl = document.documentElement.dir === 'rtl';
      sc.scrollBy({ left: dir * (rtl ? -1 : 1) * Math.min(sc.clientWidth * 0.8, 600), behavior: 'smooth' });
    });
  });
  /* video modal */
  $$('[data-video-modal-open]').forEach(btn => {
    btn.addEventListener('click', () => {
      const m = document.getElementById(btn.dataset.videoModalOpen); if (!m) return;
      m.setAttribute('aria-hidden', 'false'); lockScroll(true);
      const v = $('video', m); if (v) { loadVideo(v, false); v.muted = false; v.currentTime = 0; playSafe(v); }
    });
  });
  function closeVideoModals() { $$('[data-video-modal][aria-hidden="false"]').forEach(m => { m.setAttribute('aria-hidden', 'true'); const v = $('video', m); v && v.pause(); lockScroll(false); }); }
  $$('[data-video-modal-close]').forEach(b => b.addEventListener('click', closeVideoModals));

  /* ---------- cart ---------- */
  const drawer = $('[data-cart-drawer]');
  function cartOpen(open) {
    if (!drawer) return; drawer.setAttribute('aria-hidden', open ? 'false' : 'true'); lockScroll(open);
  }
  function bindDrawer(root) {
    $$('[data-cart-close]', root).forEach(b => b.addEventListener('click', () => cartOpen(false)));
    $$('[data-line-qty]', root).forEach(inp => inp.addEventListener('change', () => changeLine(inp.closest('[data-line]'), parseInt(inp.value, 10))));
    $$('[data-line-plus]', root).forEach(b => b.addEventListener('click', () => { const l = b.closest('[data-line]'); const i = $('[data-line-qty]', l); changeLine(l, parseInt(i.value, 10) + 1); }));
    $$('[data-line-minus]', root).forEach(b => b.addEventListener('click', () => { const l = b.closest('[data-line]'); const i = $('[data-line-qty]', l); changeLine(l, Math.max(0, parseInt(i.value, 10) - 1)); }));
    $$('[data-line-remove]', root).forEach(b => b.addEventListener('click', () => changeLine(b.closest('[data-line]'), 0)));
    bindQuickAdd(root);
  }
  function updateCount(n) { $$('[data-cart-count]').forEach(el => { el.textContent = n; el.classList.toggle('is-empty', !n); }); }
  async function refreshDrawer(openIt) {
    if (!drawer) { try { const c = await (await fetch(ajaxUrl(T.routes.cart, ''), { headers: { 'Accept': 'application/json' } })).json(); updateCount(c.item_count); } catch (e) {} return; }
    let ok = false;
    try {
      const url = (T.routes.root && T.routes.root !== '/' ? T.routes.root : '') + '/?sections=cart-drawer';
      const r = await fetch(url, { headers: { 'Accept': 'application/json' } });
      const html = await r.json();
      ok = applyDrawerHtml(html['cart-drawer']);
    } catch (e) { console.warn('[theme] drawer refresh failed', e); }
    if (!ok) {
      // Section rendering unavailable (e.g. inside some editors): keep the count right and send the customer to the cart page.
      try { const c = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json(); updateCount(c.item_count); } catch (e) {}
      if (openIt) { window.location.href = T.routes.cart || '/cart'; }
      return;
    }
    if (openIt) cartOpen(true);
  }
  async function changeLine(lineEl, qty) {
    if (!lineEl) return; lineEl.classList.add('is-loading');
    const onPage = !!lineEl.closest('[data-cart-page]');
    try {
      const body = { line: parseInt(lineEl.dataset.line, 10), quantity: qty };
      if (!onPage) { body.sections = 'cart-drawer'; body.sections_url = (T.routes.root && T.routes.root !== '/' ? T.routes.root : '') + '/'; }
      const r = await fetch(ajaxUrl(T.routes.cart_change, 'change'), { method: 'POST', headers: AJAX_HEADERS, body: JSON.stringify(body) });
      if (!r.ok) throw new Error('change failed ' + r.status);
      if (onPage) { window.location.reload(); return; }
      let d = null; try { d = await r.json(); } catch (e) {}
      if (!(d && d.sections && applyDrawerHtml(d.sections['cart-drawer']))) await refreshDrawer(false);
    } catch (e) { lineEl.classList.remove('is-loading'); toast(T.strings.error); }
  }
  function ajaxUrl(route, suffix) { route = route || ('/cart/' + suffix); return route.endsWith('.js') ? route : route + '.js'; }
  const AJAX_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  function applyDrawerHtml(html) {
    if (!drawer || !html) return false;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer]');
    if (!fresh) return false;
    drawer.innerHTML = fresh.innerHTML; drawer.dataset.count = fresh.dataset.count; updateCount(parseInt(fresh.dataset.count, 10) || 0); bindDrawer(drawer); drawer.classList.remove('is-loading');
    return true;
  }
  async function addToCart(items, btn, form) {
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    const useDrawer = T.cart_type === 'drawer' && !!drawer;
    if (useDrawer) { drawer.classList.add('is-loading'); cartOpen(true); } // open instantly, fill when the reply lands
    try {
      const body = { items };
      if (useDrawer) { body.sections = 'cart-drawer'; body.sections_url = (T.routes.root && T.routes.root !== '/' ? T.routes.root : '') + '/'; }
      const r = await fetch(ajaxUrl(T.routes.cart_add, 'add'), { method: 'POST', headers: AJAX_HEADERS, body: JSON.stringify(body) });
      const txt = await r.text();
      let d = null; try { d = JSON.parse(txt); } catch (e) { d = null; }
      if (r.status === 422 && d) { drawer && drawer.classList.remove('is-loading'); toast(d.description || d.message || T.strings.error); return false; }
      if (!r.ok && d && (d.description || d.message)) { drawer && drawer.classList.remove('is-loading'); toast(d.description || d.message); return false; }
      if (!r.ok) throw new Error('add failed ' + r.status);
      if (useDrawer) {
        if (!(d && d.sections && applyDrawerHtml(d.sections['cart-drawer']))) await refreshDrawer(true);
        return 'drawer';
      }
      window.location.href = T.routes.cart; return true;
    } catch (e) {
      console.warn('[theme] add to cart via AJAX failed, falling back to form submit', e);
      if (form && form.tagName === 'FORM') { form.removeAttribute('data-product-form'); form.submit(); return 'fallback'; }
      const f = document.createElement('form'); f.method = 'post'; f.action = T.routes.cart_add || '/cart/add'; f.style.display = 'none';
      items.forEach(it => { const i = document.createElement('input'); i.name = 'id'; i.value = it.id; f.appendChild(i); const q = document.createElement('input'); q.name = 'quantity'; q.value = it.quantity || 1; f.appendChild(q); });
      document.body.appendChild(f); f.submit(); return 'fallback';
    } finally { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } }
  }
  function bindQuickAdd(root) {
    $$('[data-quick-add]', root).forEach(b => {
      if (b.dataset.bound) return; b.dataset.bound = '1';
      b.addEventListener('click', async () => { const ok = await addToCart([{ id: parseInt(b.dataset.quickAdd, 10), quantity: 1 }], b); if (ok === true) toast(T.strings.added); });
    });
  }
  if (drawer) bindDrawer(drawer);
  bindQuickAdd(document);
  $$('[data-cart-open]').forEach(a => a.addEventListener('click', e => { if (T.cart_type === 'drawer' && drawer) { e.preventDefault(); cartOpen(true); } }));
  /* cart page qty */
  const cartPage = $('[data-cart-page]');
  if (cartPage) bindDrawer(cartPage);

  /* ---------- product page ---------- */
  const pdp = $('[data-pdp]');
  if (pdp) {
    const form = $('[data-product-form]', pdp);
    const idInput = $('[data-variant-id]', pdp);
    const variantsJson = $('[data-variants-json]', pdp);
    const variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
    const atc = $('[data-atc]', pdp);
    const atcPrice = $('[data-atc-price]', pdp);
    const priceWrap = $('[data-price-wrap]', pdp);
    const stickyPrice = $('[data-sticky-price]', pdp);
    const qtyInput = $('[data-qty-input]', pdp);
    /* quantity */
    $$('[data-qty-plus]', pdp).forEach(b => b.addEventListener('click', () => { qtyInput.value = parseInt(qtyInput.value || 1, 10) + 1; syncAtcPrice(); }));
    $$('[data-qty-minus]', pdp).forEach(b => b.addEventListener('click', () => { qtyInput.value = Math.max(1, parseInt(qtyInput.value || 1, 10) - 1); syncAtcPrice(); }));
    qtyInput && qtyInput.addEventListener('change', () => { if (parseInt(qtyInput.value, 10) < 1) qtyInput.value = 1; syncAtcPrice(); });
    function currentVariant() { const id = parseInt(idInput.value, 10); return variants.find(v => v.id === id); }
    function syncAtcPrice() { const v = currentVariant(); if (!v || !atcPrice) return; const q = parseInt((qtyInput && qtyInput.value) || 1, 10); atcPrice.textContent = money(v.price * q); }
    /* variant picker */
    const picker = $('[data-variant-picker]', pdp);
    if (picker && variants.length) {
      picker.addEventListener('change', () => {
        const chosen = $$('fieldset', picker).map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
        $$('fieldset', picker).forEach((fs, i) => { const s = $('[data-option-value]', fs); if (s && chosen[i]) s.textContent = chosen[i]; });
        const v = variants.find(x => x.options.every((o, i) => o === chosen[i]));
        if (!v) { atc.disabled = true; $('.buy__atc-label', atc).textContent = T.strings.unavailable; return; }
        idInput.value = v.id;
        atc.disabled = !v.available; $('.buy__atc-label', atc).textContent = v.available ? T.strings.add_to_cart : T.strings.sold_out;
        if (priceWrap) {
          const now = $('[data-price]', priceWrap); const was = $('[data-compare]', priceWrap); const save = $('[data-save]', priceWrap);
          now && (now.textContent = money(v.price));
          if (was) { if (v.compare_at_price > v.price) { was.textContent = money(v.compare_at_price); was.hidden = false; if (save) { save.textContent = save.textContent.replace(/\d+/, Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price)); save.hidden = false; } } else { was.hidden = true; save && (save.hidden = true); } }
        }
        stickyPrice && (stickyPrice.textContent = money(v.price));
        syncAtcPrice();
        if (v.featured_media) { const th = $(`[data-thumb="${v.featured_media.id}"]`, pdp); th && th.click(); }
        const url = new URL(window.location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      });
    }
    /* ATC */
    if (form) {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const ok = await addToCart([{ id: parseInt(idInput.value, 10), quantity: parseInt((qtyInput && qtyInput.value) || 1, 10) }], atc, form);
        if (ok === true) toast(T.strings.added);
      });
    }
    const stickySubmit = $('[data-sticky-submit]', pdp);
    stickySubmit && stickySubmit.addEventListener('click', () => { if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });
    /* sticky ATC visibility */
    const sticky = $('[data-sticky-atc]', pdp);
    if (sticky && atc && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(en => { const vis = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; sticky.classList.toggle('is-visible', vis); sticky.setAttribute('aria-hidden', !vis); }, { threshold: 0 });
      io.observe(atc);
    }
    /* gallery */
    const main = $('[data-gallery-main]', pdp);
    const slides = $$('.gallery-main__slide', pdp);
    const thumbs = $$('[data-thumb]', pdp);
    function goTo(i) {
      if (!slides[i]) return;
      main.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      thumbs.forEach((t, j) => { t.classList.toggle('is-active', j === i); t.setAttribute('aria-selected', j === i); });
      slides.forEach((s, j) => { s.classList.toggle('is-active', j === i); const v = $('video', s); if (v) { if (j === i) { loadVideo(v, false); } else { v.pause(); } } });
    }
    /* if the first slide is a video, prepare it (metadata only) */
    { const fv = slides[0] && $('video', slides[0]); if (fv) { loadVideo(fv, false); fv.preload = 'metadata'; } }
    thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
    $('[data-gallery-prev]', pdp) && $('[data-gallery-prev]', pdp).addEventListener('click', () => { const i = slides.findIndex(s => s.classList.contains('is-active')); goTo((i - 1 + slides.length) % slides.length); });
    $('[data-gallery-next]', pdp) && $('[data-gallery-next]', pdp).addEventListener('click', () => { const i = slides.findIndex(s => s.classList.contains('is-active')); goTo((i + 1) % slides.length); });
    if (main) { let st; main.addEventListener('scroll', () => { clearTimeout(st); st = setTimeout(() => { const i = Math.round(main.scrollLeft / main.clientWidth); const idx = document.documentElement.dir === 'rtl' ? Math.abs(i) : i; thumbs.forEach((t, j) => { t.classList.toggle('is-active', j === idx); }); slides.forEach((s, j) => { s.classList.toggle('is-active', j === idx); if (j === idx) { const v = $('video', s); v && loadVideo(v, false); } }); }, 80); }, { passive: true }); }
    /* description toggle */
    $$('[data-desc-toggle]', pdp).forEach(b => {
      const d = b.closest('[data-desc]');
      if (d.scrollHeight <= d.clientHeight + 24) { d.classList.remove('pdp__desc--clamp'); }
      b.addEventListener('click', () => { const open = d.classList.toggle('is-open'); b.textContent = open ? (T.strings.read_less || 'Read less') : (T.strings.read_more || 'Read more'); });
    });
    /* recommendations (Shopify) */
    const rec = $('[data-recommendations]');
    if (rec && rec.dataset.url && !$('.grid', rec)) {
      fetch(rec.dataset.url).then(r => r.text()).then(html => { const doc = new DOMParser().parseFromString(html, 'text/html'); const inner = doc.querySelector('[data-recommendations]'); if (inner && $('.grid', inner)) { rec.innerHTML = inner.innerHTML; bindQuickAdd(rec); $$('.reveal', rec).forEach(el => el.classList.add('is-visible')); } else { rec.remove(); } }).catch(() => {});
    }
  }

  /* ---------- collection sort ---------- */
  $$('[data-sort]').forEach(sel => sel.addEventListener('change', () => { const u = new URL(window.location); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); window.location.href = u.toString(); }));

  /* ---------- global escape ---------- */
  trapEsc(() => { navToggle(false); searchToggle(false); cartOpen(false); closeVideoModals(); });

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:section:load', () => { hoist(); $$('[data-video]').forEach(v => { if (v.dataset.play === 'hero' || v.dataset.play === 'inview') loadVideo(v, true); }); bindQuickAdd(document); });
})();
